module.exports = __webpack_public_path__ + "img/outlet-banner.d97a4b90.png";